(ns teamoesterreich.admin-mode.event.detail.event-member-selector
  (:require [clojure.string]
            [clojure.walk :as walk]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [goog.json :as json]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.admin-mode.event.detail.member-selector.filter-router :as filter-router]
            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.event :as d-event]

            [teamoesterreich.admin-mode.event.detail.member-selector.selector-region :as selector-region]

            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            ))




(defn vec-remove [coll pos]
  ;(println "remove " coll "2" pos)
  (into (subvec (vec coll) 0 pos) (subvec (vec coll) (inc pos))))

(defn add-base-org-filter []
  (let [b-org (first (d-rights/get-rights-orgId-filter d-rights/CLASSIC))]{:type  :base-org
   :name  "Filter Organisations Einheit"
   :short (first (d-rights/get-rights-orgId-filter d-rights/CLASSIC))
   :val   (first (d-rights/get-rights-orgId-filter d-rights/CLASSIC))}))


(defn add-or-block [!event-conditions]
  (swap! !event-conditions conj
         [(add-base-org-filter)]
         ))





(defn add-item-popup [!add-new-popup on-add-cb]
  (let [!selected (r/atom nil)]
    (fn [] [mui/modal
            {
             :aria-labelledby  "simple-modal-title"
             :aria-describedby "simple-modal-description"
             :style            {:display        "flex"
                                :marginRight    "auto"
                                :marginLeft     "auto"
                                :alignItems     "center"
                                :justifyContent "center"}
             :open             (not (nil? @!add-new-popup))
             }
            [:div
             {
              :class "modal"
              :style {:width 600 :overflow-y "hidden"}}
             [:h2 "Neues Kriterium"]
             [mui/select
              {:fullWidth true
               :value     (or @!selected "")
               :onChange  (fn [e]
                            ;(js/console.log "Change type  -> " (h/event-value e))
                            (reset! !selected (h/event-value e)))
               }
              (for [{:keys [key name typeInfo]} (filter #(not (:hide %)) filter-router/FILTER_OPTIONS)]
                ^{:key (str "and-block-" key)}
                [mui/menu-item {:key key :value key} name " " typeInfo])
              ]

             [mui/button
              {:variant   "contained"
               :startIcon (r/as-element [keyboard-arrow-left])
               :style     {:marginLeft "5px"}
               :onClick   #(reset! !add-new-popup nil)
               }
              "Abbrechen"]

             (when @!selected
               [mui/button
                {:variant   "contained"
                 :startIcon (r/as-element [save])
                 :style     {:marginRight "5px" :float "right"}
                 :onClick   (fn []
                              (reset! !add-new-popup nil)
                              (on-add-cb (filter-router/get-defaults (keyword @!selected)))
                              )
                 }
                "Ok"])

             ]])

    ))


(defn or-block [idx !event-conditions !edit-mode]

  (let [!st (r/atom {:add-new-popup nil :mode :show-all})
        !edit-item-popup (r/cursor !st [:edit-item-popup])
        !add-new-popup (r/cursor !st [:add-new-popup])]

    (fn [idx !event-conditions !edit-mode]
      (let [!this-block (r/cursor !event-conditions [idx])]
        [:div {:style {:padding "10px 15px 10px 15px " :borderRadius "7px" :border "2px dotted darkgrey" :width "fit-content" :margin "0 auto 0 auto"}} (str (inc idx) ":")

         [add-item-popup !add-new-popup
          (fn [new-type]
            (println "add-item " @!event-conditions "-" idx "++" new-type)
            (reset! !event-conditions (assoc (vec @!event-conditions) idx
                                                                      (conj (nth @!event-conditions idx)
                                                                            new-type
                                                                            ))))]

         [filter-router/edit-filter-popup !edit-item-popup !this-block]

         (for [[id item] (map-indexed (fn [i v] [i v]) @!this-block)]
           ;{1 {:type "age" :name "Alter"} 2 {:type "profile-completed" :name "Alter"} 3 {:type "language" :name "Alter"}}]
           ^{:key (str "and-block-" id)}
           [:div
            (when (> id 0) "und")
            (when (> id 0) [:br])
            (if @!edit-mode
              [mui/chip
               (merge
                 {:style      {:width            "345px"
                               :marginRight      "5px"
                               :textAlign        "left"
                               :background-color "#f4b1c2"}
                  :label      (r/as-element
                                [:div
                                 {:style {:width "270px" :overflow "hidden" :text-overflow "ellipsis"}
                                  :title (str (:name item) ": " (:short item))}
                                 (str (:name item) ": " (:short item))])
                  :icon       (r/as-element [edit])
                  :deleteIcon (r/as-element [delete-forever])

                  :onClick    #(reset! !edit-item-popup id)}
                (when-not (= :base-org (:type item))
                  [:onDelete   #(swap! !event-conditions assoc idx (vec-remove @!this-block id))]))
               ]
              [mui/tooltip {:title (str (:name item) ": " (:short item))}
               [mui/chip {:style {:width "345px" :marginRight "5px" :textAlign "left" :background-color "#f4b1c2"}
                          :label (r/as-element [:div {:style {:width "270px" :overflow "hidden" :text-overflow "ellipsis"}} (str (:name item) ": " (:short item))])
                          :icon  (when @!edit-mode (r/as-element [edit]))
                          }]])]
           )


         [:br]
         (when @!edit-mode
           [mui/button {:label     "und Kriterium hinzufügen"
                        :variant   "outlined"
                        :startIcon (r/as-element [add])
                        :style     {:margin "5px"}
                        :onClick   #(reset! !add-new-popup idx)
                        } "hinzufügen"])

         (when (and @!edit-mode (= 1 (count @!this-block)))

           [mui/button {:label     "Kriterium entfernen"
                        :variant   "outlined"
                        :startIcon (r/as-element [delete-forever])
                        :onClick   (fn []
                                     (println "Kriterium entfernen - " idx " - " @!event-conditions)
                                     (swap! !event-conditions vec-remove idx))
                        } "entfernen"]
           )

         ;[:pre "Data\n" (pr-str this-block)]

         ])
      )))


(defn get-geofence [disabled?]
  [selector-region/region-selector disabled?]
  )


(defn show-hard-all [!edit-mode !event-conditions !cnt-hard]
  [mui/grid
   {:container true
    :direction "row"
    :justify   "flex-start"
    }
   [mui/grid
    {:item true :xs 12}
    [:h3 "Pflichtkriterien (potentielle Anzahl " @!cnt-hard ")"]
    [mui/grid
     {:item true :xs 12}
     [mui/chip {:label "manuell zugeteilt" :color "#e10032" :icon (r/as-element [info])}]]

    (for [[idx item-block] (map-indexed (fn [i v] [i v]) @!event-conditions)]
      ^{:key (str "or-block-" idx)}
      [mui/grid {:item true :xs 12}
       "oder"
       [:br]
       [or-block idx !event-conditions !edit-mode]]
      )
    (when @!edit-mode
      [mui/grid
       {:item true :xs 12 :style {:marginTop "20px"}}
       [mui/button {:variant   "outlined" :color "primary"
                    :startIcon (r/as-element [add])
                    :onClick   #(add-or-block !event-conditions)
                    :style     {:marginRight "10px"}}
        "Oder Kriterium hinzufügen"]])


    ;[mui/grid
    ; {:item true :xs 12 :style {:marginTop "120px" :backgroundColor "pink"}}
    ; [:pre
    ;  (pr-str @!event-conditions)
    ;  ]
    ; ]
    ]])

(defn show-soft-all [!edit-mode !event-conditions !cnt-soft]
  [mui/grid
   {:container true
    :direction "row"
    :justify   "flex-start"
    }
   [mui/grid
    {:item true :xs 12}
    [:h3 "Alarmierungs Kriterien (potentielle Anzahl " @!cnt-soft ")"]
    ]
   [mui/grid
    {:item true :xs 12}
    [mui/chip {:label "Pflichtkriterien" :color "#e10032" :icon (r/as-element [info])}]
    [:br]
    "und"]

   ;[mui/grid
   ; {:item true :xs 12}
   ; "oder" [:br]
   ; [mui/chip {:label "Pflichtkriterien" :color "#e10032" :icon (r/as-element [info])}]]

   (for [[idx item-block] (map-indexed (fn [i v] [i v]) @!event-conditions)]
     ^{:key (str "or-block-" idx)}
     [mui/grid {:item true :xs 12}
      (when (> idx 0) "oder")
      (when (> idx 0) [:br])
      [or-block idx !event-conditions !edit-mode]]
     )

   (when @!edit-mode
     [mui/grid
      {:item true :xs 12 :style {:marginTop "20px"}}
      [mui/button {:variant   "outlined" :color "primary"
                   :startIcon (r/as-element [add])
                   :onClick   #(add-or-block !event-conditions)
                   :style     {:marginRight "10px"}}
       "Oder Kriterium hinzufügen"]])


   ;[mui/grid
   ; {:item true :xs 12 :style {:marginTop "120px" :backgroundColor "pink"}}
   ; [:pre
   ;  (pr-str @!event-conditions)
   ;  ]
   ; ]
   ])


(defn get-it [disabled]
  (let [!edit-mode (r/cursor store/app-state [:event-conditions :editMode])
        !event (r/cursor store/app-state [:selected-event])
        !cnt-soft (r/cursor !event [:_crowdtaskerEvent-calc-alarmable])
        !cnt-hard (r/cursor !event [:_crowdtaskerEvent-calc-acceptable])
        !event-conditions (r/cursor store/app-state [:event-conditions])
        !event-conditions-loaded? (r/cursor !event-conditions [:loaded?])
        !soft-event-conditions (r/cursor !event-conditions [:soft])
        !hard-event-conditions (r/cursor !event-conditions [:hard])]
    (fn []
      (if (not @!event-conditions-loaded?)
        (reset! !event-conditions {:loaded? true
                                   :hard    (walk/keywordize-keys (js->clj (json/parse (or (:crowdtaskerEvent-memberFilter @!event) "[]"))))
                                   :soft    (walk/keywordize-keys (js->clj (json/parse (or (:crowdtaskerEvent-memberSoftFilter @!event) "[]"))))
                                   })

        )
      (let [changed? (or
                       (not= @!soft-event-conditions (:crowdtaskerEvent-memberSoftFilter @!event))
                       (not= @!hard-event-conditions (:crowdtaskerEvent-memberFilter @!event)))]
        [mui/grid
         {:container true
          :direction "row"
          :justify   "flex-start"
          }
         [mui/grid
          {:item true :md 6 :xs 12}
          [show-hard-all !edit-mode !hard-event-conditions !cnt-hard]]
         [mui/grid
          {:item true :md 6 :xs 12}
          [show-soft-all !edit-mode !soft-event-conditions !cnt-soft]]
         [mui/grid
          {:item true :md 12 :xs 12 :style {:padding-top "20px"}}
          (when (and (not @!edit-mode) (not disabled))
            [mui/button {
                         :variant   "contained"
                         :startIcon (r/as-element [edit])
                         :onClick   #(reset! !edit-mode true)
                         } "Bearbeiten"])

          (when (and (not @!edit-mode) disabled (d-rights/is-superuser?))
            [mui/button {
                         :variant   "outlined"
                         :style     {:color "orange"}
                         :startIcon (r/as-element [edit])
                         :onClick   #(reset! !edit-mode true)
                         } "Bearbeiten (superuser)"])

          (when @!edit-mode
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   (fn []
                                      (reset! !edit-mode false)
                                      (reset! !event-conditions-loaded? false))
                         } "Abbrechen"])
          (when @!edit-mode
            [mui/button {:variant   "contained"
                         :style     {:marginLeft "20px"}
                         :disabled  (if changed? false true)
                         :color     "primary"
                         :onClick   (fn []
                                      (d-event/>event-save-event-conditions (:crowdtaskerEvent-uuid @!event) @!hard-event-conditions @!soft-event-conditions)
                                      (reset! !edit-mode false))
                         :startIcon (r/as-element [save])}
             "Speichern"])
          ]
         ]
        )
      )))

























